<template>
  <div class="root-security">
    <div class="main-nav styleCard">
      <ul class="style-nav style1">
        <li
          v-for="tab in instTabs"
          :key="tab.id"
          class="router-link"
          @click="selectedInstTab = tab.alias"
          :class="{ active: selectedInstTab === tab.alias }"
        >
          {{ tab.name }}
        </li>
      </ul>
    </div>

    <for-aws v-if="selectedInstTab === 'AWS'"></for-aws>
  </div>
</template>

<script>
import ForAws from "../components/ForAws.component";
export default {
  name: "Security.container",

  components: {
    ForAws
  },
  data() {
    return {
      selectedInstTab: "AWS",
      instTabs: [
        {
          id: 0,
          name: "AWS",
          alias: "AWS"
        }
      ]
    };
  }
};
</script>

<style scoped>
.styleCard {
  font-family: Montserrat, serif;
  box-shadow: 0 9px 20px rgba(0, 0, 0, 0.05);
  border-radius: 5px;
}
.main-nav {
  display: flex;
  flex-direction: column;
  border-radius: 0;
  background: white;
  margin-top: 0.3rem !important;
}
.style-nav {
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  position: relative;
}
/*
        .style-nav.style2 li{
            border-radius: 5px 5px 0px 0px;
            transition:transform 0.1s ease;
        }
        .style-nav.style2 li:not(:last-child){
            margin-right:2px;
        }
        */

.style-nav .router-link {
  max-width: 150px;
  min-width: 72px;
  height: 28px;
  margin: 0;
  cursor: pointer;
  background: white;
  border-radius: 0;
  font-size: 11px;
  color: black;
  text-align: center;
  vertical-align: middle;
  line-height: 28px;
  border-bottom: 2px solid transparent;
  flex-grow: 1;
  transition: background 0.3s ease, color 0.3s ease;
}

.style-nav.style2 li:not(.empty):hover {
  transform: translateY(5px);
}

.style-nav.style2 li.active {
  border-bottom: 2px solid #44a2d2 !important;
  color: #44a2d2;
}

.style-nav.style1 .router-link:not(.empty):hover {
  background: #44a2d2;
  color: white;
  text-decoration: none;
}

.style-nav.style1 .router-link.active {
  border-bottom: 2px solid #44a2d2 !important;
  background: #44a2d2;
  color: white;
  text-decoration: none;
}
.inter-time-container {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}
.inter-time-container span:first-child {
  margin-bottom: 0.2rem;
  display: block;
}
.inter-time-container span {
  font-size: 10px;
  font-weight: bold;
}

.inter-time img {
  margin-left: 5px;
  margin-right: 7px;
  position: relative;
  top: 1px;
}
.inter-time {
  width: 80px;
  display: inline-block;
  height: 100%;
  vertical-align: top;
  line-height: 14px;
}
.profile-avatar {
  width: 40px;
  display: inline-block;
  height: 100%;
  position: relative;
}
.profile-part {
  border-left: 2px solid #eff3f6;
}
.profile-avatar img {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
  border-radius: 50%;
}
.profile-dropdown {
  left: -210px;
  padding: 10px;
  width: 250px;
  text-align: center;
}

.bttn {
  width: 100%;
  margin-top: 0.5rem;
  background: #44a2d2;
  color: white;
  border: 0;
  border-radius: inherit;
  padding: 5px;
  font-size: 12px;
  font-family: inherit;
  cursor: pointer;
}
.author-card img {
  margin-bottom: -10px;
  margin-top: 20px;
}
</style>
